import React, { useCallback, useEffect, useMemo, useRef } from "react";
import "./Navbar.css";
import logo from "../../assets/logo-smaller.png";
import { useHistory, useLocation } from "react-router-dom";
import { Link } from 'react-router-dom';
import useSpatialNavigation from "../../useSpatialNavigation";
import { Film, HouseDoorFill, MusicNoteBeamed, Tv } from "react-bootstrap-icons";

const NavBar = () => {
  const navItemRefs = useRef([]);
  const history = useHistory();
  const location = useLocation();

  useSpatialNavigation("upperbox", {
    enterTo: "last-focused",
    restrict: 'self-first',
    straightOnly: false,
    straightOverlapThreshold: 0.4,
  });

  const menu = useMemo(() => [
    { id: "Home", label: "Home", path: "/", icon: <HouseDoorFill /> },
    { id: "Shows", label: "Shows", path: "/shows", icon: <Tv /> },
    { id: "Movies", label: "Movies", path: "/movies", icon: <Film /> },
    { id: "Songs", label: "Songs", path: "/songs", icon: <MusicNoteBeamed /> },
    // { id: "Kids", label: "Kids", path: "/kids", icon: <PersonArmsUp size={25} /> },
  ], []);

  // Compute selected tab from current path
  const selectedTab = useMemo(() => {
    const current = menu.find(item => item.path === location.pathname);
    return current?.id || null;
  }, [location.pathname, menu]);

  const handleTabClick = useCallback((item) => {
    if (item.path !== location.pathname) {
      history.push(item.path);
    }
  }, [history, location.pathname]);

  // useEffect(() => {
  //   const index = menu.findIndex(item => item.path === location.pathname);
  //   if (index !== -1 && navItemRefs.current[index]) {
  //     navItemRefs.current[index].focus();
  //   }
  // }, [location.pathname, menu]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Enter' || event.keyCode === 13) {
        const focusedElement = document.activeElement;
        const index = navItemRefs.current.findIndex(ref => ref === focusedElement);
        if (index !== -1) {
          handleTabClick(menu[index]);
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [handleTabClick, menu]);

  return (
    <div className="header">
      <div id="upperbox" className="tabBar row justify-content-center">
        <div className="align-self-center d-flex align-items-center position-absolute">
          <img
            src={logo}
            alt="TamilOdai.com"
          />
          <span className="fw-bold title">தமிழ் ஓடை</span>
          {/* தமிழ் ஓடை */}
        </div>
          <div className="d-flex justify-content-center m-1">
            {menu.map((item, index) => (
              <Link
                key={index}
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleTabClick(item);
                }}
                ref={(el) => (navItemRefs.current[index] = el)}
                tabIndex="0"
                className={`tabButton focusable fw-bold ${selectedTab === item.id ? "active" : ""}`}
              >
                {item.icon}
              </Link>
            ))}
          </div>
      </div>
    </div>
  );
};

export default NavBar;
